@let evaluation = evaluationSg();
@let commands = evaluation?.commands ?? [];

<h4>Commands</h4>

<ol>
  @for (command of commands; track $index) {
    @let showPayloadSg = createToggle($index);
    @let showPayload = showPayloadSg();

    <li
      #command
      (click)="showPayloadSg.set(!showPayload)"
    >
      {{ command.operation }}
    </li>

    @if (showPayload) {
      <atn-ds-code [json]="command.payload" />
    }
  }
</ol>
